"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeRenewalChangesDateBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeRenewalChangesDateBanner = /** @class */ (function (_super) {
    __extends(AnnualHomeRenewalChangesDateBanner, _super);
    function AnnualHomeRenewalChangesDateBanner(props) {
        return _super.call(this, props) || this;
    }
    AnnualHomeRenewalChangesDateBanner.prototype.render = function () {
        var renewalStartDate = (0, commonFunctions_1.formatDateDMY)(this.props.interaction.renewalDetails.periodStartDate);
        return ((0, jsx_runtime_1.jsx)("div", { className: "section-panel banner banner-info banner-info-multiple-paragraphs", children: (0, jsx_runtime_1.jsxs)("p", { className: "mx-4 mb-0 grid-col-2", children: ["Heads up - any changes you make will only apply to your next year's policy. You can make changes up to your renewal date, ", renewalStartDate, "."] }) }));
    };
    return AnnualHomeRenewalChangesDateBanner;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeRenewalChangesDateBanner = AnnualHomeRenewalChangesDateBanner;
//# sourceMappingURL=AnnualHomeRenewalChangesDateBanner.js.map